import { render, staticRenderFns } from "./ProfessionalInfoEdit.vue?vue&type=template&id=2df34fec"
import script from "./ProfessionalInfoEdit.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports